import React from "react";
import "react-date-range/dist/theme/default.css";
import { makeStyles } from "@material-ui/core";
import { KButton } from "@kyburz/kdesign-system";

const useStyle = makeStyles(() => ({
  root: {
    bottom: 10,
    zIndex: 10,
  },
  date: {
    boxShadow: "4px 4px 12px 0px rgba(0,0,0,0.22)",
    borderRadius: 4,
  },
  timeWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  time: {
    border: "1px solid #e9e9e9",
    borderRadius: 4,
    padding: 10,
    fontSize: 14,
    width: 95,
    margin: "0 5px 0 5px",
    fontFamily: "Roboto, sans-serif",
  },
  apply: {
    width: 160,
    margin: "0 auto",
    marginBottom: 10,
    marginTop: 10,
  },
  bottomWrapper: {
    background: "white",
    display: "flex",
    flexDirection: "column",
  },
  helperRoot: {
    display: "flex",
    flexDirection: "column",
    background: "white",
  },
  helperWrapper: {
    background: "white",
    display: "flex",
    justifyContent: "center",
    width: 335,
    cursor: "pointer",
  },
  helperIcon: {
    marginRight: 8,
    marginTop: 5,
  },
  help: {
    background: "#efefef",
    width: 310,
    padding: 8,
    marginTop: 16,
    marginBottom: 16,
    display: "flex",
    alignItems: "center",
    fontSize: 14,
  },
}));

interface Props {
  setApplyClicked: (v?: any) => void;
  timeActive: boolean;
  applyText?: string;
  startTime: string;
  endTime: string;
  onTimeChange?: (v: any) => void | undefined;
  applyButton?: boolean;
}

const TimeButton: React.FC<Props> = ({
  timeActive,
  setApplyClicked,
  applyText = "Apply",
  startTime,
  endTime,
  onTimeChange,
  applyButton = true,
}: Props) => {
  const classes = useStyle();

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const endDate = new Date(today);
  endDate.setFullYear(endDate.getFullYear() + 1);

  return (
    <div className={classes.root}>
      <div
        className={classes.bottomWrapper}
        style={applyButton ? { paddingTop: 20 } : undefined}
      >
        {timeActive && (
          <div className={classes.timeWrapper}>
            <input
              required
              data-testid="startTime"
              type="time"
              className={classes.time}
              value={startTime}
              onChange={onTimeChange}
              name="startTime"
            />
            <input
              required
              data-testid="endTime"
              type="time"
              className={classes.time}
              value={endTime}
              onChange={onTimeChange}
              name="endTime"
            />
          </div>
        )}
        {applyButton ? (
          <KButton className={classes.apply} onClick={setApplyClicked}>
            {applyText}
          </KButton>
        ) : null}
      </div>
    </div>
  );
};

export default TimeButton;
